
<template>
  <v-app id="app" class="router_css">
    <!-- Mobile Header: shown on mobile devices when signed in -->
    <MobileHeaderComponent
      v-if="approvalAndMobile && $route.name != 'Signin' && $route.name != 'SigninUser'"
      :header-title="$store.state.organization_name || 'RIMS'"
    />

    <div
      v-if="$route.name == 'WmsDashboard' || $route.name == 'EmailVerification' || $route.name == 'OTPVerification' || $route.name == 'ResetPassword'"
      :class="[
        $route.path.includes('admin') ? 'container-fluid' : 'main_wraper_wms',
        isSidebarExpanded ? 'sidebar-expanded' : (($route.name !== 'Signin' && $route.name != 'SigninUser') || $route.name == 'WmsDashboard') ? '' : 'sidebar-expanded-hide'
      ]">
      <!-- <Navbar v-if="$route.name!='WmsDashboard' && !$store.state.currentUser.roles.includes('service_franchisee')"/> -->
      <LeftNavbar v-if="($route.name != 'WmsDashboard' || $route.name != 'returnProcess') && !(servicefranchisee || approvalAndMobile)" />
      <router-view :class="$route.name != 'Signin' && $route.name != 'returnProcess' && $route.name != 'SigninUser'  && !(servicefranchisee || approvalAndMobile) ? 'px-4 router_css' : ''"/>
    </div>

    <div
      v-else
      :class="[
        $route.path.includes('admin') ? 'container-fluid' : 'main_wraper',
        isSidebarExpanded ? 'sidebar-expanded' : $route.name !== 'Signin' && $route.name != 'SigninUser' ? 'sidebar-expanded-hide' : ''
      ]"
    >
      <!-- <Navbar v-if="$route.name!='Signin' && !$store.state.currentUser.roles.includes('service_franchisee')" /> -->
      <LeftNavbar v-if="$route.name != 'Signin' && $route.name != 'returnProcess' && $route.name != 'SigninUser' && !(servicefranchisee || approvalAndMobile)" />
      <router-view :class="$route.name != 'Signin' && $route.name != 'returnProcess' && $route.name != 'SigninUser'  && !(servicefranchisee || approvalAndMobile) ? 'px-4 router_css' : ''"/>
    </div>
  </v-app>
</template>


<script>

// import Navbar from '@/components/Navbar'
import LeftNavbar from './components/LeftNavbar.vue';
import MobileHeaderComponent from './components/commoncomponents/MobileHeaderComponent.vue';

export default {
  name: 'App',
  components: {
    LeftNavbar,
    MobileHeaderComponent
  },
  computed: {
    // paddingStyle() {
    //   if (this.$store.state.signedIn) {
    //     return this.$store.state.currentUser.roles.includes('service_franchisee') ? { paddingLeft: '45px !important' } : { paddingLeft: '0px' };
    //   }

    // },
    servicefranchisee() {
      if (this.$store.state.signedIn) {
        return this.$store.state.currentUser.roles.includes('service_franchisee');
      }

     },
    isSidebarExpanded() {
      return this.$store.state.isSidebarExpanded;
    },
    approvalAndMobile() {
      return this.$store.state.isMobile === true;
    }
},
mounted() {
    // Trigger text replacement when the component is mounted
    this.$triggerTextReplacement();
  },
  watch: {
    $route() {
      this.$triggerTextReplacement();
    },
    '$store.state.someData'(newValue) {
      this.$triggerTextReplacement();
    }
  },
  // created() {
  //   if(!this.$store.state.currentUser.username){
  //     this.$httpSecured
  //       .delete("/api/v1/logout")
  //       .then((response) => {
  //         this.$store.commit("unsetCurrentUser");
  //         this.$store.commit("unsetSelectedLot");
  //         this.$store.commit("setCurrentWarehouse", {distribution_id: ''})
  //         this.$router.replace("/");
  //         this.$store.commit('setSidebarExpanded', true);
  //       })
  //       .catch((error) => {
  //         this.$toast.error("Error in logging out");
  //       });
  //   }
  //   this.$store.commit('setSidebarExpanded', true);
  // }
}
</script>

<style>
#app {
  font-family: 'Inter', sans-serif, 'Avenir', Helvetica, Arial;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.v-application__wrap {
  background: #F6F7F9 !important;
}

.v-data-table-header {
  white-space: nowrap;
}

.sidebar-expanded {
  width: calc(100vw);
}

.sidebar-expanded-hide {
  width: calc(100vw);
}

/* .router_css .sidebar-expanded  {
  margin-left: 4.7rem;
}

.router_css .sidebar-expanded-hide {
  margin-left: 4.7rem;
} */
.sidebar-expanded .router_css {
  margin-left: 16.0rem !important;
}

.sidebar-expanded-hide .router_css {
  margin-left: 4.7rem !important;
}
</style>
